import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { Environment } from '@sb/library/base';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationInterceptor } from './authentication/authentication-interceptor';
import { RouteReuseStrategy } from '@angular/router';
import { TransitionRouteReuseStrategy } from './transition-route-reuse.strategy';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
        { provide: RouteReuseStrategy, useClass: TransitionRouteReuseStrategy },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ApiModule {
    // This allows us to set the environment used in a library module from the app
    static setEnvironment(environment: Environment): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [{ provide: Environment, useValue: environment }]
        };
    }
}
